import React, { useState, useMemo, useEffect } from 'react';
import InputMask from "react-input-mask";
import { sendNotification } from '../services/Functions'
import { toast } from 'react-toastify';
import Api from '../services/Api'
import camera from '../assets/icons/camera.svg';

const ListItemCategory = ({ id, category, thumbnail, priority, active, onDelete, loadItem, setLoading }) => {
  const [toggleItem, setToggleItem] = useState([]);
  const [stateCategory, setStateCategory] = useState(category);
  const [stateThumbnail, setStateThumbnail] = useState(thumbnail);
  const [statePriority, setStatePriority] = useState(priority ? priority : 0);
  const [stateActive, setStateActive] = useState(active);

  // useMemo: executa quando determinado estado for alterado, neste caso o estado 'stateThumbnail'
  const preview = useMemo(() => {
    if(thumbnail !== "" && thumbnail === stateThumbnail){
      return thumbnail;
    } else {
      return stateThumbnail ? URL.createObjectURL(stateThumbnail) : null;
    }
  }, [stateThumbnail]);
  
  function onChangeThumbnailFile(e){
    if(e.target.files[0]){
      let file_size = e.target.files[0].size;
      //let file_name = e.target.files[0].name;
      //let file_type = e.target.files[0].type;
      //console.log('executou o file change: ' +  file_size);
      //Se maior que um 1mb(1048576)
      if(parseInt(file_size) >= 1048000) {
        toast.error("Imagem não suportada! A imagem deve ter no máximo 1MB", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }else{
        setStateThumbnail(e.target.files[0])
      }
    }
  };

  async function handleSubmit(e){
    e.preventDefault();
    if(stateCategory !== "" && statePriority ){
      setLoading(true);
      var fileThumbnail = stateThumbnail;
      //Cria um estrutura Multiform Data;
      const data = new FormData();
      data.append('id', id);
      data.append('category', stateCategory.trim());
      if(typeof fileThumbnail === "object" && thumbnail !== fileThumbnail.name){
        data.append('thumbnail', thumbnail);
        data.append('file', fileThumbnail);
      }
      data.append('priority', statePriority);
      data.append('active', stateActive);

      try {
        const response = await Api.saveItem("/store-category", data);
        console.log(response);
        if(response.hasOwnProperty('_id') || response?.ok){
          toast.success("Operação realizada com sucesso!", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setToggleItem([]);
          const reloadItem = loadItem;
          reloadItem();
          setLoading(false);
        } else {
          toast.error("Falha ao realizar a operação!", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error("(*) Preencha todos os campos obrigatórios!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }
  
  return (
      <li className={toggleItem[0] === id ? "itemDashboardList itemDashboardListActive" : "itemDashboardList"} style={active || stateActive ? {} : {opacity: 0.4}}>
        <div className="row headList" onClick={() => {toggleItem[0] !== id ? setToggleItem([id]) : setToggleItem([])}}>
          <div className="col-10">
            <span>{stateCategory}</span>
          </div>
          <div className="col-2 text-right">
            <span className={`iconItem ${toggleItem[0] === id ? 'fas fa-angle-up fa-lg ' : 'fas fa-angle-down fa-lg '}`}></span>
          </div>
        </div>
        {toggleItem[0] === id ?
          <div className="row">
            <div className="col-12">
              <hr/>
              <form onSubmit={handleSubmit}>
                <div className="row v-center">
                  <div className="col-12">
                    <label className="switch itemDashboardListSwitch">
                      <input type="checkbox" value={stateActive} checked={stateActive} onChange={() => setStateActive(!stateActive)} />
                      <div className="slider"></div>
                    </label>
                    <div className="row">
                      {/*<div className="col-12">
                        <div className="form-group">
                          <label className="labelImage">Imagem:</label>
                          <label id="thumbnail" style={{ backgroundImage: `url(${preview})` }} className={stateThumbnail ? 'has-thumbnail' : ''}>
                            <input type="file" accept=".jpg, .jpeg, .png" onChange={onChangeThumbnailFile} />
                            <img src={camera} alt="Select img" />
                          </label>
                        </div>
                      </div>*/}
                      <div className="col-12">
                        <div className="form-group" style={{marginTop: 30}}>
                          <label className="labelInput">Nome: *</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Nome"
                            value={stateCategory}
                            onChange={event => setStateCategory(event.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label className="labelInput">Prioridade:</label>
                          <input 
                            type="number" 
                            className="form-control" 
                            placeholder="Número de ordenação"
                            value={statePriority}
                            onChange={event => setStatePriority(event.target.value)}
                          />
                        </div>
                      </div>     
                    </div>     
                  </div>     
                      
                  <div className="col-12 text-right">
                    <button type="button" className="btn btn-delete" onClick={onDelete}> Excluir </button>
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <button type="submit" className="btn btn-default"> Salvar </button>
                  </div>
                </div>
              </form>
                
            </div>
          </div>
          : '' }
      </li>
  );
};

export default ListItemCategory;
